<template>
  <div class="container-video-mcp">
    <section class="cover-video" :class="{'loop-video': bgLoop}" v-if="!regularPlayer">
      <div class="video_jw">
        <div v-if="!bgLoop" ref="videoPlaceholder" @click="showVideo()" class="placeholder">
          <img width="100%" :src="placeholder">
        </div>
        <div class="content-player">
          <div :id="videoUniqId"></div>
        </div>
      </div>
   </section>
    <section class="cover-video" :class="{'loop-video': bgLoop}" v-if="regularPlayer">
      <video ref="video_player_regular" muted no-controls :autoplay="bgLoop" :loop="bgLoop">
        <source :src="videoId" type="video/mp4">        
        Sorry, your browser doesn't support embedded videos.
    </video>
   </section>
  </div>
</template>

<style lang="scss">
  .container-video-mcp {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    z-index: 1;

    .cover-video {
      video {
        object-fit: cover;
        width: 100%;
        height: 100vh;
      }
    }

    .loop-video {
      pointer-events: none !important;

      video {
        pointer-events: none !important;
      }

      .jw-controls {
        overflow: hidden;
        display: none;
      }
    }

    .jw-controls {
      overflow: hidden;
    }

    .jw-display-controls {
      display: inline-block;
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .jw-display-icon-rewind {
      display: none !important;
    }

    .content-player {
      height: 100vh;
    }

    .content-player {
      height: 100vh;
    }

    .jw-skin-webapp.jwplayer.jw-flag-aspect-mode {
      height: 100vh !important;
    }

    .jw-display-icon-next {
      display: none !important;
    }

    .jw-display-container {
      display: flex;
      height: 100%;
      text-align: center;
      align-items: center;
      justify-content: center;
    }

    .placeholder {
      height: 100vh;
      transition: opacity 0.5s ease-in-out;

      img {
        object-fit: cover;
        height: 100%;
      }
    }
  }

</style>

<script>

  export  default {
    name: 'VidepMcpViewer',
    props: {
      playVideo: {
        type: Boolean,
        default: false
      },
      videoUniqId: {
        type: String,
        default: ``
      },
      mcpId: {
        type: String,
        default: ``
      },
      bgLoop: {
        type: Boolean,
        default: false
      },
      regularPlayer: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        videoObject: {}
      }
    },
    mounted() {
      this.showVideo()
    },
    computed:{
      videoId() {
        const id = this.mcpId.split(';')
        if(id[0])
          return id[0]
        return this.mcpId
      },
      placeholder() {
        const id = this.mcpId.split(';')
        if(id[1])
          return id[1]
        return ``
      }
    },
    watch: {
      videoId() {
        if(!this.regularPlayer)
          this.showVideo()
        else
          this.showLoop()
      },
      playVideo(val) {
        this.videoObject =  window.FMG.getJWPlayerInstance(this.videoUniqId)

        if(val) {
          this.PlayVideo()
        }
        else {
          this.showPlaceholder()
        }   
      }
    },
    methods: {
      showPlaceholder() {
        this.videoObject.pause()
        this.$refs['videoPlaceholder'].style.display = 'block'
        setTimeout(() => {
          this.$refs['videoPlaceholder'].style.opacity = 1
        }, 100)
      },
      PlayVideo() {
        this.$refs['videoPlaceholder'].style.opacity = 0
        setTimeout(() => {
          this.$refs['videoPlaceholder'].style.display = 'none'
          this.videoObject.play()
        }, 700)
      },
      showLoop() {
        this.$refs['video_player_regular'].load()
      },
      showVideo() {

        window.FMG.playVOD({
          mcpId: this.videoId,
          nodeId: this.videoUniqId,
          autoplay: this.bgLoop, 
          muteAdsOnAutoplay: true,
          forceHLS: true,
          enableRating: true,
          isPrebidEnabled: true,
          isVmap: true,
          repeat: this.bgLoop,
          dfp: {
            prefix: 'rd.',
            advalue: 'univision_section_noticias/inicio',
            sz: '640x480'
          }
        })        
      }
    }
  }

</script>
